import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { FAQS } from './salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-cream py-12 sm:py-16" data-id="element-69" data-mp="1bmd8ncjfgm7p">
      <div className="mx-auto max-w-2xl px-5" data-id="element-70" data-mp="1gitwe5mpsyk9">
        <h2 className="text-center font-display text-[1.5rem] font-extrabold tracking-tight text-charcoal sm:text-[2.1rem]" data-id="element-71" data-mp="1glpubtykbn8p">
          Preguntas frecuentes
        </h2>

        <div className="mt-6 space-y-2" data-id="element-72" data-mp="289hvzd8qpvvt">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-2xl border border-stone bg-white shadow-[0_10px_30px_-26px_rgba(56,37,34,0.5)]" data-id="element-73" data-mp="1uhk3me390emc" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-3.5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-74" data-mp="2n5z7c4gxjaid">
                  <span className="font-display text-[0.9rem] font-semibold leading-snug text-charcoal sm:text-[0.98rem]" data-id="element-75" data-mp="10rvu92p248mt">
                    {faq.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden strokeWidth={3} data-id="element-76" data-mp="19t2cbg7ctri6" />
                </button>
                <AnimatePresence initial={false} data-id="element-77" data-mp="1xhljfseo3y8o">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-78" data-mp="1slo6zx6izc16">
                      <p className="px-5 pb-4 font-sans text-[0.86rem] leading-relaxed text-taupe" data-id="element-79" data-mp="23992ne1b7mjg">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}